import React, {useEffect, useState} from "react";
import QuestionkeywordsSubcomponent from "../exercisesubcomponents/QuestionkeywordsSubcomponent";
import ActionsComponent from "../components/ActionsComponent";
import globalVars from "../utils/globalVars";

const getSubComponents = props => {
    let subcomponents = [];
    let c = (props.exercise?.answercount) ? props.exercise.answercount : Number.MAX_VALUE;
    for (let i = 0; i < Math.min(props.exercise.answers.length, c); i++) {
        subcomponents.push(
            <QuestionkeywordsSubcomponent
                style={{color: 'lightgrey'}}
                key={i + 1}
                idx={i + 1}
                expectedKeywords={props.exercise.answers}
                feedbackMode={props.feedbackMode}

            />
        );
    }
    return subcomponents;
};

export default function QuestionkeywordsComponent(props) {
    const [showSolution, setShowSolution] = useState(false);

    function handleShowSolution() {
        setShowSolution(!showSolution)
    }

    const [showFeedback, setShowFeedback] = useState(false);

    function handleShowFeedback() {
        setShowFeedback(!showFeedback)
    }

    return (
        <div>
            {getSubComponents({...props, feedbackMode: showFeedback ? 'mode_feedback' : 'mode_normal'})}
            <ActionsComponent
                onToggleShowSolution={handleShowSolution}
                onToggleShowFeedback={handleShowFeedback}
                {...props}
            />
            {showSolution &&
            <ul style={{backgroundColor: globalVars.solutionMode.on, width: "40vw"}}>
                {
                    props.exercise.answers &&
                    !Array.isArray(props.exercise.answers) &&
                    <p style={{color: 'red'}}>{props.exercise.answers}</p>
                }
                {
                    props.exercise.answers &&
                    Array.isArray(props.exercise.answers) &&
                    // <p>{props.exercise.answers.toString()}</p>
                    props.exercise.answers.map(
                        (e, i) => {
                            return (
                                <li style={{color: '#666'}} key={i}>{e}</li>
                            )
                        }
                    )
                }
            </ul>
            }
            {/*{props.exercise.answercount && <p>answercount = {props.exercise.answercount}</p>}*/}
            {/*{props.exercise.exactanswer && <p>exactanswer = {props.exercise.exactanswer.toString()}</p>}*/}
        </div>
    );
}
